import React from 'react' 
import dummy from './images/grow-biz.jpg'

export default function GrowYourBusiness() {
  return (
    <>
      <div className="container grow-business-con">
        <div className="row row-cols-2 grow-business-row">
                <div className="col contain-contant-area">
                  <div className="containt-area-grow-bis">
                    <h2>ACCELERATE YOUR BUSINESS GROWTH
                    </h2>
                    <p>Raj Digital Marketing is a vibrant and forward-thinking digital marketing agency from Pune, India. We are passionate about building, shaping, and energising brands. Our core strength lies in a powerful mix of creative strategy, brand marketing expertise, and in-depth knowledge of mobile, research, and digital media. We also craft tailored programming and app solutions that align with your business vision. </p>
                  </div>
                  
                  </div> 
                <div className="col Image-area-grow-bis">
                    <img src={dummy} alt="" />
                </div>
        </div>

      </div>
    </>
  )
}
